import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-class-builder-remove-placeholder',
  components: {
    EdClassSubjectPlaceholderItem: () => import(/* "EdClassSubjectPlaceholderItem" */ '../ed-class-subject-placeholder-item/ed-class-subject-placeholder-item.component.vue'),
  },
})
export default class EdClassBuilderRemovePlaceholder extends Vue {
  @Prop({ default: null }) readonly params: any;

  get placeholder() {
    return this.params.placeholder;
  }

  isConfirmationRemoveModalOpen = false;

  emitOnRemoveBlock() {
    this.close();
    this.params.onRemoveBlock(this.placeholder);
  }

  close() {
    this.$EdModal.closeModal();
  }
}